import actions from './sendActions'

export default {
  namespaced: true,
  actions,
}
